export const slugify = (string = '') =>
  string
    .replace(/[^\w ]/g, '')
    .split(' ')
    .map(part => part.toLowerCase())
    .join('-')
